import type { LeadListItem } from '../api/crm';

export interface FlowState {
  labels: string[];
  done: boolean[];
  current: number;
  doneCount: number;
}

type FlowLead = Pick<LeadListItem, 'kind' | 'registrationSentAt' | 'registrationClickedAt' | 'convertedAt' | 'introCallAt' | 'offerSentAt' | 'contractSentAt' | 'clientPartnerId'>;

export const AFFILIATE_FLOW_LABELS = ['Lead přijat', 'Posouzení', 'Registrace', 'Kontrola v platformě', 'Affiliate partner'];
export const CLIENT_FLOW_LABELS = ['Lead přijat', 'Úvodní call', 'Nabídka', 'Připomínky a jednání', 'Smlouva a klient'];

function build(labels: string[], done: boolean[]): FlowState {
  const current = done.findIndex((d) => !d);
  return { labels, done, current, doneCount: done.filter(Boolean).length };
}

export function affiliateFlow(lead: FlowLead, paired: boolean): FlowState {
  const sent = !!lead.registrationSentAt;
  const converted = !!lead.convertedAt;
  return build(AFFILIATE_FLOW_LABELS, [true, sent, !!lead.registrationClickedAt || converted, converted, paired]);
}

export function clientFlow(lead: FlowLead): FlowState {
  const converted = !!lead.clientPartnerId;
  return build(CLIENT_FLOW_LABELS, [true, !!lead.introCallAt, !!lead.offerSentAt, !!lead.contractSentAt || converted, converted]);
}

export function leadFlow(lead: FlowLead & { affiliatePaired?: boolean }): FlowState {
  return lead.kind === 'inzerent' ? clientFlow(lead) : affiliateFlow(lead, !!lead.affiliatePaired);
}

type DealLead = Pick<LeadListItem, 'status' | 'contractSentAt' | 'clientPartnerId' | 'expectedMonthlyEur'>;

export function isConfirmedDeal(lead: DealLead, slug: string | null | undefined): boolean {
  if (lead.status === 'lost' || lead.status === 'rejected') return false;
  const confirmedStatus = slug === 'affilmaster' ? 'qualified' : 'won';
  return lead.status === confirmedStatus || !!lead.contractSentAt || !!lead.clientPartnerId;
}

export function dealValues(leads: DealLead[], slug: string | null | undefined): { table: number; closed: number } {
  let table = 0;
  let closed = 0;
  for (const lead of leads) {
    if (lead.status === 'lost' || lead.status === 'rejected') continue;
    const value = lead.expectedMonthlyEur ?? 0;
    if (isConfirmedDeal(lead, slug)) closed += value; else table += value;
  }
  return { table, closed };
}
